import gql from 'graphql-tag'
export default gql`mutation createEnvironmentClassMutation($environmentClass: BaseEnvironmentClass!) {
  createEnvironmentClass(environmentClass: $environmentClass) {
    code
    description
    minCement
    maxWbf
    requirementMax
    deviationMax
    maxDeviationsAllowed
    minimumAirPercentages {
      largestGrain
      airPercentage
    }
    encroachment
    id
  }
}`